import { type AuthToken } from '@reliance/types/models/Auth';
import config from '../services/config';

export const referenceMaterial = (getToken: () => AuthToken) => ({
  getContent: (id): string => {
    return `${config.api.url}/reference-material/${id}/content?token=${
      getToken().accessToken
    }`;
  },
  getEpubContent: (id): string => {
    return `${config.api.url}/reference-material/${id}/content.epub?token=${
      getToken().accessToken
    }`;
  },
});
